/**
 * @fileoverview gRPC-Web generated client stub for somewear.api.v1
 * @enhanceable
 * @public
 */
// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.29.0
// source: api/tracking.proto
/* eslint-disable */
// @ts-nocheck
import * as grpcWeb from 'grpc-web';
import * as location_proto_pb from '../location_proto_pb'; // proto import: "location_proto.proto"
import * as route_proto_pb from '../route_proto_pb'; // proto import: "route_proto.proto"
import * as api_tracking_pb from '../api/tracking_pb'; // proto import: "api/tracking.proto"
export class TrackingClient {
    client_;
    hostname_;
    credentials_;
    options_;
    constructor(hostname, credentials, options) {
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname.replace(/\/+$/, '');
        this.credentials_ = credentials;
        this.options_ = options;
    }
    methodDescriptorGetLocationStream = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/GetLocationStream', grpcWeb.MethodType.SERVER_STREAMING, api_tracking_pb.LocationStreamRequest, location_proto_pb.LocationResponseList, (request) => {
        return request.serializeBinary();
    }, location_proto_pb.LocationResponseList.deserializeBinary);
    getLocationStream(request, metadata) {
        return this.client_.serverStreaming(this.hostname_ +
            '/somewear.api.v1.Tracking/GetLocationStream', request, metadata || {}, this.methodDescriptorGetLocationStream);
    }
    methodDescriptorGetLocations = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/GetLocations', grpcWeb.MethodType.UNARY, api_tracking_pb.GetLocationsRequest, api_tracking_pb.GetLocationsResponse, (request) => {
        return request.serializeBinary();
    }, api_tracking_pb.GetLocationsResponse.deserializeBinary);
    getLocations(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/GetLocations', request, metadata || {}, this.methodDescriptorGetLocations, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/GetLocations', request, metadata || {}, this.methodDescriptorGetLocations);
    }
    methodDescriptorCreateTrackingLocations = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/CreateTrackingLocations', grpcWeb.MethodType.UNARY, api_tracking_pb.CreateTrackingLocationsRequest, location_proto_pb.LocationResponseList, (request) => {
        return request.serializeBinary();
    }, location_proto_pb.LocationResponseList.deserializeBinary);
    createTrackingLocations(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/CreateTrackingLocations', request, metadata || {}, this.methodDescriptorCreateTrackingLocations, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/CreateTrackingLocations', request, metadata || {}, this.methodDescriptorCreateTrackingLocations);
    }
    methodDescriptorCreateWaypoint = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/CreateWaypoint', grpcWeb.MethodType.UNARY, api_tracking_pb.CreateWaypointRequest, route_proto_pb.RouteResponse, (request) => {
        return request.serializeBinary();
    }, route_proto_pb.RouteResponse.deserializeBinary);
    createWaypoint(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/CreateWaypoint', request, metadata || {}, this.methodDescriptorCreateWaypoint, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/CreateWaypoint', request, metadata || {}, this.methodDescriptorCreateWaypoint);
    }
    methodDescriptorDeleteRoute = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/DeleteRoute', grpcWeb.MethodType.UNARY, api_tracking_pb.DeleteRouteRequest, api_tracking_pb.DeleteRouteRequest, (request) => {
        return request.serializeBinary();
    }, api_tracking_pb.DeleteRouteRequest.deserializeBinary);
    deleteRoute(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/DeleteRoute', request, metadata || {}, this.methodDescriptorDeleteRoute, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/DeleteRoute', request, metadata || {}, this.methodDescriptorDeleteRoute);
    }
    methodDescriptorGetLiveRoutes = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/GetLiveRoutes', grpcWeb.MethodType.UNARY, api_tracking_pb.GetLiveRoutesRequest, api_tracking_pb.GetLiveRoutesResponse, (request) => {
        return request.serializeBinary();
    }, api_tracking_pb.GetLiveRoutesResponse.deserializeBinary);
    getLiveRoutes(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/GetLiveRoutes', request, metadata || {}, this.methodDescriptorGetLiveRoutes, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/GetLiveRoutes', request, metadata || {}, this.methodDescriptorGetLiveRoutes);
    }
    methodDescriptorGetLastKnownRoutes = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/GetLastKnownRoutes', grpcWeb.MethodType.UNARY, api_tracking_pb.GetLastKnownRoutesRequest, api_tracking_pb.GetLastKnownRoutesResponse, (request) => {
        return request.serializeBinary();
    }, api_tracking_pb.GetLastKnownRoutesResponse.deserializeBinary);
    getLastKnownRoutes(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/GetLastKnownRoutes', request, metadata || {}, this.methodDescriptorGetLastKnownRoutes, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/GetLastKnownRoutes', request, metadata || {}, this.methodDescriptorGetLastKnownRoutes);
    }
    methodDescriptorGetRoutes = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/GetRoutes', grpcWeb.MethodType.UNARY, api_tracking_pb.GetRoutesRequest, api_tracking_pb.GetRoutesResponse, (request) => {
        return request.serializeBinary();
    }, api_tracking_pb.GetRoutesResponse.deserializeBinary);
    getRoutes(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/GetRoutes', request, metadata || {}, this.methodDescriptorGetRoutes, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/GetRoutes', request, metadata || {}, this.methodDescriptorGetRoutes);
    }
    methodDescriptorGetWorkspaceRoutes = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/GetWorkspaceRoutes', grpcWeb.MethodType.UNARY, api_tracking_pb.GetWorkspaceRoutesRequest, api_tracking_pb.GetWorkspaceRoutesResponse, (request) => {
        return request.serializeBinary();
    }, api_tracking_pb.GetWorkspaceRoutesResponse.deserializeBinary);
    getWorkspaceRoutes(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/GetWorkspaceRoutes', request, metadata || {}, this.methodDescriptorGetWorkspaceRoutes, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/GetWorkspaceRoutes', request, metadata || {}, this.methodDescriptorGetWorkspaceRoutes);
    }
    methodDescriptorGetRouteLocations = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/GetRouteLocations', grpcWeb.MethodType.UNARY, api_tracking_pb.GetRouteLocationsRequest, api_tracking_pb.GetRouteLocationsResponse, (request) => {
        return request.serializeBinary();
    }, api_tracking_pb.GetRouteLocationsResponse.deserializeBinary);
    getRouteLocations(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/GetRouteLocations', request, metadata || {}, this.methodDescriptorGetRouteLocations, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/GetRouteLocations', request, metadata || {}, this.methodDescriptorGetRouteLocations);
    }
    methodDescriptorGetWaypoints = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/GetWaypoints', grpcWeb.MethodType.UNARY, api_tracking_pb.GetWaypointsRequest, api_tracking_pb.GetWaypointsResponse, (request) => {
        return request.serializeBinary();
    }, api_tracking_pb.GetWaypointsResponse.deserializeBinary);
    getWaypoints(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/GetWaypoints', request, metadata || {}, this.methodDescriptorGetWaypoints, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/GetWaypoints', request, metadata || {}, this.methodDescriptorGetWaypoints);
    }
    methodDescriptorExportGpx = new grpcWeb.MethodDescriptor('/somewear.api.v1.Tracking/ExportGpx', grpcWeb.MethodType.UNARY, api_tracking_pb.ExportGpxRequest, api_tracking_pb.ExportGpxResponse, (request) => {
        return request.serializeBinary();
    }, api_tracking_pb.ExportGpxResponse.deserializeBinary);
    exportGpx(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Tracking/ExportGpx', request, metadata || {}, this.methodDescriptorExportGpx, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Tracking/ExportGpx', request, metadata || {}, this.methodDescriptorExportGpx);
    }
}
//# sourceMappingURL=TrackingServiceClientPb.js.map